export default __webpack_public_path__ + "static/media/vip6.6f8e9e8e.webp";